
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSleepingFilled as ObiAisTargetSleepingFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-sleeping-filled.js';
 
 
 

 
 export const ObiAisTargetSleepingFilled = createComponent({
   react: React,
   tagName: 'obi-ais-target-sleeping-filled',
   elementClass: ObiAisTargetSleepingFilledElement,
   events: {
     
   }
  });
 
 